const Divider = {
    // The styles all button have in common
    baseStyle: {
        borderColor: '#F1F1F1',  //Eliminates the default click blue border effect
    },
};
export default Divider;

